import React, { useState } from 'react';

const ChatSettings = () => {
  const [settings, setSettings] = useState({
    typingSpeed: 50,
    responseDelay: 1000,
    maxMessageLength: 500,
    enableTypingIndicator: true,
    enableSoundNotifications: false,
    autoGreeting: true,
    greetingMessage: 'Hello! How can I assist you today?',
    fallbackMessage: 'I apologize, but I don\'t understand. Could you please rephrase?',
    maxConversationHistory: 50,
    sessionTimeout: 30
  });

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  const saveSettings = () => {
    // TODO: API call to save settings
    alert('Settings saved successfully!');
  };

  return (
    <div className="container">
      <h1>Chat Settings</h1>
      
      <div className="card">
        <h3>Typing & Response Settings</h3>
        
        <div className="form-group">
          <label className="form-label">
            Typing Speed (characters per second): {settings.typingSpeed}
          </label>
          <input 
            type="range"
            min="10"
            max="100"
            value={settings.typingSpeed}
            onChange={(e) => handleSettingChange('typingSpeed', parseInt(e.target.value))}
            style={{ width: '100%' }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            Response Delay (milliseconds): {settings.responseDelay}
          </label>
          <input 
            type="range"
            min="0"
            max="5000"
            step="100"
            value={settings.responseDelay}
            onChange={(e) => handleSettingChange('responseDelay', parseInt(e.target.value))}
            style={{ width: '100%' }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Max Message Length</label>
          <input 
            type="number"
            className="form-input"
            value={settings.maxMessageLength}
            onChange={(e) => handleSettingChange('maxMessageLength', parseInt(e.target.value))}
            min="50"
            max="2000"
          />
        </div>
      </div>

      <div className="card">
        <h3>User Experience Settings</h3>
        
        <div className="form-group">
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input 
              type="checkbox"
              checked={settings.enableTypingIndicator}
              onChange={(e) => handleSettingChange('enableTypingIndicator', e.target.checked)}
            />
            Enable Typing Indicator
          </label>
        </div>

        <div className="form-group">
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input 
              type="checkbox"
              checked={settings.enableSoundNotifications}
              onChange={(e) => handleSettingChange('enableSoundNotifications', e.target.checked)}
            />
            Enable Sound Notifications
          </label>
        </div>

        <div className="form-group">
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input 
              type="checkbox"
              checked={settings.autoGreeting}
              onChange={(e) => handleSettingChange('autoGreeting', e.target.checked)}
            />
            Auto Greeting
          </label>
        </div>
      </div>

      <div className="card">
        <h3>Messages Configuration</h3>
        
        <div className="form-group">
          <label className="form-label">Greeting Message</label>
          <textarea 
            className="form-input"
            value={settings.greetingMessage}
            onChange={(e) => handleSettingChange('greetingMessage', e.target.value)}
            rows="3"
            placeholder="Enter greeting message"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Fallback Message</label>
          <textarea 
            className="form-input"
            value={settings.fallbackMessage}
            onChange={(e) => handleSettingChange('fallbackMessage', e.target.value)}
            rows="3"
            placeholder="Enter fallback message for unrecognized inputs"
          />
        </div>
      </div>

      <div className="card">
        <h3>Session Management</h3>
        
        <div className="form-group">
          <label className="form-label">Max Conversation History</label>
          <input 
            type="number"
            className="form-input"
            value={settings.maxConversationHistory}
            onChange={(e) => handleSettingChange('maxConversationHistory', parseInt(e.target.value))}
            min="10"
            max="200"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Session Timeout (minutes)</label>
          <input 
            type="number"
            className="form-input"
            value={settings.sessionTimeout}
            onChange={(e) => handleSettingChange('sessionTimeout', parseInt(e.target.value))}
            min="5"
            max="120"
          />
        </div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <button className="btn btn-primary" onClick={saveSettings}>
          Save Settings
        </button>
      </div>
    </div>
  );
};

export default ChatSettings;